import {CurrencyDollarIcon} from "@heroicons/react/20/solid";
import React, {Fragment, useEffect, useRef, useState} from "react";
import SockJsClient from 'react-stomp';
import {baseUrl, vtDancerMessageURI} from "../../requests/NetworkRequestAuth0";
import {getVenueSession} from "../../requests/AppSession";
import {useNavigate} from "react-router-dom";
import {Skeleton} from "@mui/material";
import {NumericFormat} from "react-number-format";
import LoginError from "../login/LoginError";
import {findVenueDancerDisplay} from "../requests/AppRequestStage";
import {useAuth} from "@workos-inc/authkit-react";
import {tableRequest} from "../requests/AppRequestTableRequest";
import {tip} from "../requests/AppRequestTip";
// import sound from "./sound/cash2.mp3";

export default function VTDancerDisplay() {
    let navigate = useNavigate();

    const {getAccessToken, user, isLoading} = useAuth();

    let clientRef;

    const timeout = useRef();

    const [venueId, setVenueId] = React.useState(null);
    const [venueName, setVenueName] = React.useState(null);
    const [venueImage, setVenueImage] = React.useState(null);

    const [clubErrorMessage, setClubErrorMessage] = React.useState(null);

    const [dancer, setDancer] = React.useState(null);
    const [dancerEffect, setDancerEffect] = React.useState(false);
    const [dancerErrorMessage, setDancerErrorMessage] = React.useState(null);

    const [isPageLoading, setIsPageLoading] = React.useState(true);

    const [tipped, setTipped] = React.useState(false);
    const [tipAmount, setTipAmount] = React.useState(1);
    const [tipErrorMessage, setTipErrorMessage] = React.useState(null);

    const [dancerTotalTipAmount, setDancerTotalTipAmount] = React.useState(0);
    const [dancerTotalTipPercent, setDancerTotalTipPercent] = React.useState(0);
    const [dancerTotalTipGoal, setDancerTotalTipGoal] = React.useState(100);

    const [vt, setVT] = React.useState(null);
    const [vtBeforeError, setVTBeforeError] = React.useState(null);

    const [vtOnPageLoad, setVTOnPageLoad] = React.useState(null);
    const [totalAmountTipped, setTotalAmountTipped] = React.useState(0);

    const [vtErrorMessage, setVtErrorMessage] = React.useState(null);

    const [tableRequestFeatureFlag, setTableRequestFeatureFlag] = useState(false);
    const [tableId, setTableId] = React.useState(null);
    const [hasRequestedTable, setHasRequestedTable] = React.useState(false);
    const [hasTipped, setHasTipped] = useState(false);
    const [minimumTableRequestTip, setMinimumTableRequestTip] = useState(false);
    const [showTableForm, setShowTableForm] = useState(false);

    // Floating "+1" effect shown each time the guest taps TIP.
    const [tipFloaters, setTipFloaters] = useState([]);
    const tipFloaterId = useRef(0);

    // Server-confirmed running total. Optimistic taps update the displayed
    // total immediately; tipSuccess reconciles it to this authoritative value.
    const confirmedTotalRef = useRef(0);

    // Count of optimistic taps not yet confirmed by the server, so a failed
    // request can roll the displayed total back by exactly that amount.
    const pendingOptimisticRef = useRef(0);

    const showTipFloater = () => {
        const id = tipFloaterId.current++;
        setTipFloaters((f) => [...f, id]);
        setTimeout(() => {
            setTipFloaters((f) => f.filter((x) => x !== id));
        }, 1000);
    };

    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.venueId && venueSession.venueId !== null) {
                setVenueId(venueSession.venueId);
                //setVenueName(venueSession.venueName);
            } else {
                navigate('/login/mobile', {replace: true});
            }

            if (!venueSession.stageTipFeatureFlag) {
                navigate('/login/mobile', {replace: true});
            }
        })

        return function cleanup() {

        };
    }, []);

    const getSuccess = async responseJson => {
        setIsPageLoading(false);
        if (
            responseJson &&
            responseJson.id &&
            responseJson.userVTInformation
        ) {
            setVT(responseJson.userVTInformation.vtLeft);
            setVTBeforeError(responseJson.userVTInformation.vtLeft);
            setVTOnPageLoad(responseJson.userVTInformation.vtLeft);

            setVenueImage(responseJson.imgFileName);
            setVenueName(responseJson.name);
            setTableRequestFeatureFlag(responseJson.tableRequestFeatureFlag);
            setMinimumTableRequestTip(responseJson.minimumTableRequestTip);
        } else {
            setVtErrorMessage("Error accessing remaining VT, please refresh and verify Internet Connection.");
        }

        if (
            responseJson &&
            responseJson.id &&
            responseJson.dancer &&
            responseJson.dancer.id
        ) {
            setDancer(responseJson.dancer);
            setTotalAmountTipped(responseJson.totalTippedAmount);
            // Seed the server-confirmed counter so later tips reconcile on top
            // of any amount already tipped before this page load.
            confirmedTotalRef.current = responseJson.totalTippedAmount || 0;
            pendingOptimisticRef.current = 0;
            if (responseJson.tableRequestFeatureFlag && responseJson.totalTippedAmount >= responseJson.minimumTableRequestTip) {
                setHasTipped(true);
                setHasRequestedTable(responseJson.hasRequestedTable);
                setTableId(responseJson.tableId);
            }
        } else {
            setDancerErrorMessage("Error setting dancer, please refresh and verify Internet Connection.");
        }
    };

    const getError = forceLogout => {
        setIsPageLoading(false);
        setClubErrorMessage("Error getting Club information, please refresh and verify Internet Connection.");
    };

    useEffect(() => {
        if (!isLoading && venueId !== null) {
            findVenueDancerDisplay(venueId, getSuccess, getError, getAccessToken);
        }
        return function cleanup() {

        };
    }, [isLoading, venueId]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (tipped) {
                setTipped(false);
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [tipped])

    useEffect(() => {
        const timer = setTimeout(() => {
            if (dancerEffect) {
                setDancerEffect(false);
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [dancerEffect])


    const resetTableRequest = () => {
        setHasRequestedTable(false);
        setHasTipped(false);
        setTotalAmountTipped(0);
        // Reset the server-confirmed and pending-optimistic tip counters so the
        // new/cleared dancer starts from zero and tipSuccess reconciles correctly.
        confirmedTotalRef.current = 0;
        pendingOptimisticRef.current = 0;
        setShowTableForm(false);
        setTableId(null);
    };

    const onMessageReceive = (message, topic) => {
        // console.log(message);
        // console.log(topic);

        if (message && message.venueId) {
            switch (message.messageCode) {
                // case "TIP":
                //     setDancerTotalTipAmount(message.dancerTotalTipAmount);
                //     setDancerTotalTipPercent(message.dancerTotalTipPercent);
                //     break;
                case "SWITCH_GIRL":
                    resetTableRequest();
                    setDancerEffect(true);
                    setDancer(message.dancer);
                    break;
                case "END_TIPPING":
                    resetTableRequest();
                    setDancer(message.dancer);
                    break;
            }
        }
    };

    const tableRequestSuccess = async responseJson => {
        if (
            responseJson &&
            responseJson.id
        ) {
            setHasRequestedTable(true);
            setShowTableForm(false);
            //setVTBeforeError(responseJson.userVirtualTipsLeft);
            //Enable button on next dancer change
        }
    };

    const tableRequestError = forceLogout => {
        setTipErrorMessage("Error submitting table request, please verify Internet Connection and try again.");
    };

    const tipSuccess = async responseJson => {
        if (
            responseJson &&
            responseJson.tipAmount
        ) {

            //TODO figure out if 2 screens what to do, App won't let it fly anyway
            // if (vt > responseJson.userVirtualTipsLeft) {
            //     setVT(responseJson.userVirtualTipsLeft);
            // }

            // const totalAmount = vtOnPageLoad - responseJson.userVirtualTipsLeft;
            // Advance the server-confirmed total by this batch's tip amount and
            // set the display to that authoritative value. This corrects any
            // drift from the optimistic bumps applied on each button press.
            const totalAmount = confirmedTotalRef.current + tipAmount;
            confirmedTotalRef.current = totalAmount;
            // This batch is confirmed; clear the pending optimistic counter.
            pendingOptimisticRef.current = 0;

            setTotalAmountTipped(totalAmount);

            if (totalAmount >= minimumTableRequestTip) {
                setHasTipped(true);
            }

            setVTBeforeError(responseJson.userVirtualTipsLeft);
            //await new Audio(sound).play();
        } else {
            //alert("tipError2");
            window.location.reload();
            //setVtErrorMessage("Error accessing remaining VT, please refresh or logout and log back in.");
        }
    };

    const tipError = forceLogout => {
        setVT(vtBeforeError);
        // Roll the displayed total back to the last server-confirmed value,
        // undoing the optimistic taps that were in this failed request. The
        // table-request unlock is server-gated, so it needs no rollback here.
        pendingOptimisticRef.current = 0;
        setTotalAmountTipped(confirmedTotalRef.current);
        setTipErrorMessage("Error tipping, please verify Internet Connection and try again.");
    };

    const handleDebounceSearch = () => {
        clearTimeout(timeout.current)

        timeout.current = setTimeout(() => {
            tip(venueId, dancer.id, tipAmount, tipSuccess, tipError, getAccessToken);
            setTipAmount(1);
        }, 1000)
    }

    return (
        <>
            <section className="overflow-hidden bg-gray-50 dark:bg-gray-800 py-12 md:py-20 lg:py-24">
                <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="mt-2">
                        {clubErrorMessage && <LoginError errorMessage={clubErrorMessage}/>}
                    </div>

                    <div className="relative">
                        {!clubErrorMessage && venueImage && <img
                            className="mx-auto h-8"
                            src={venueImage}
                            alt={venueName}
                        />}
                        {!clubErrorMessage && !venueImage && venueName &&
                            <div
                                className="mx-auto max-w-3xl text-center text-3xl font-medium leading-9 text-gray-900 dark:text-gray-100">
                                <p>
                                    {venueName}
                                </p>
                            </div>}
                        {dancer && <blockquote className="mt-10">
                            <div className="mx-auto max-w-3xl text-center text-2xl font-medium leading-9 text-gray-900 dark:text-gray-100">
                                <p>
                                    Now on stage
                                </p>
                            </div>
                            <footer className="mt-8">
                                <div className="md:flex md:items-center md:justify-center">
                                    <div className="md:flex-shrink-0">
                                        {/*<img*/}
                                        {/*    className="mx-auto h-10 w-10 rounded-full"*/}
                                        {/*    src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"*/}
                                        {/*    alt=""*/}
                                        {/*/>*/}
                                    </div>
                                    <div className="mt-3 text-center md:mt-0">
                                        <style>{`
                                            @keyframes dancerSwitchIn {
                                                0%   { opacity: 0; transform: translateY(8px) scale(0.92); }
                                                60%  { opacity: 1; transform: translateY(0) scale(1.04); }
                                                100% { opacity: 1; transform: translateY(0) scale(1); }
                                            }
                                        `}</style>
                                        <div
                                            key={dancer.id}
                                            className={
                                                "break-words text-4xl font-extrabold tracking-tight text-gray-900 dark:text-gray-100 sm:text-5xl md:text-6xl " +
                                                (dancerEffect ? "animate-[dancerSwitchIn_0.5s_ease-out]" : "")
                                            }
                                        >
                                            {dancer.name}
                                        </div>

                                        {/*<svg className="mx-1 hidden h-5 w-5 text-pink-600 md:block" fill="currentColor" viewBox="0 0 20 20">*/}
                                        {/*    <path d="M11 0h3L9 20H6l5-20z" />*/}
                                        {/*</svg>*/}

                                        {/*<div className="text-base font-medium text-gray-500">CEO, Workcation</div>*/}
                                    </div>
                                </div>

                                {/*<div>*/}
                                {/*    <h4 className="sr-only">Status</h4>*/}
                                {/*    <p className="text-sm text-center mt-1 font-medium text-gray-900">*/}
                                {/*        <NumericFormat value={dancerTotalTipAmount} displayType={'text'}*/}
                                {/*                       decimalScale={2} fixedDecimalScale={true}*/}
                                {/*                       thousandSeparator={true} prefix={'$'}/>*/}
                                {/*    </p>*/}
                                {/*</div>*/}

                                {/*<div>*/}
                                {/*    <h4 className="sr-only">Status</h4>*/}
                                {/*    <p className="text-sm text-center mt-1 font-medium text-gray-900">*/}
                                {/*        <NumericFormat value={dancerTotalTipAmount} displayType={'text'}*/}
                                {/*                       decimalScale={2} fixedDecimalScale={true}*/}
                                {/*                       thousandSeparator={true} prefix={'$'}/>*/}
                                {/*        { } out of GOAL { }*/}

                                {/*        <NumericFormat value={dancerTotalTipGoal} displayType={'text'}*/}
                                {/*                       decimalScale={2} fixedDecimalScale={true}*/}
                                {/*                       thousandSeparator={true} prefix={'$'}/>*/}
                                {/*    </p>*/}
                                {/*    <div className="mt-6" aria-hidden="true">*/}
                                {/*        <div className="overflow-hidden rounded-full bg-gray-200">*/}
                                {/*            <div className="h-2 rounded-full bg-pink-600" style={{ width: dancerTotalTipPercent + '%' }} />*/}
                                {/*        </div>*/}
                                {/*        <div className="mt-6 hidden grid-cols-4 text-sm font-medium text-gray-600 sm:grid">*/}
                                {/*            /!*<div className="text-pink-600">Copying files</div>*!/*/}
                                {/*            /!*<div className="text-center text-pink-600">Migrating database</div>*!/*/}
                                {/*            /!*<div className="text-center">Compiling assets</div>*!/*/}
                                {/*            /!*<div className="text-right">Deployed</div>*!/*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                            </footer>
                            <div
                                className="mx-auto mt-5 max-w-3xl text-center text-2xl font-medium leading-9 text-pink-600">
                                {vt != null && dancer && dancer.name && <p
                                    className="mb-3 text-center text-sm font-semibold leading-6 text-gray-600 dark:text-gray-400">
                                    You tipped <span className="text-xl font-bold text-pink-600">{<NumericFormat
                                    value={totalAmountTipped}
                                    displayType={'text'}
                                    thousandSeparator={true}/>} VT</span>
                                </p>}
                                <div className="relative inline-block">
                                    <style>{`
                                        @keyframes tipFloatUp {
                                            0%   { opacity: 0; transform: translateY(0) scale(0.8); }
                                            20%  { opacity: 1; transform: translateY(-12px) scale(1.1); }
                                            100% { opacity: 0; transform: translateY(-70px) scale(1); }
                                        }
                                    `}</style>
                                    {/* Floating "+1" effect on each tip tap */}
                                    <div className="pointer-events-none absolute inset-x-0 top-0 flex justify-center">
                                        {tipFloaters.map((id) => (
                                            <span
                                                key={id}
                                                className="absolute animate-[tipFloatUp_1s_ease-out_forwards] text-2xl font-bold text-pink-500"
                                            >
                                                +1
                                            </span>
                                        ))}
                                    </div>
                                    <button
                                        disabled={vt === null || vt <= 0}
                                        type="button"
                                        className={
                                            "inline-flex items-center justify-center gap-2 rounded-full px-12 py-5 text-2xl font-bold text-white shadow-lg transition-transform focus:outline-none focus:ring-2 focus:ring-offset-2 active:scale-95 " +
                                            ((vt === null || vt <= 0)
                                                ? "bg-gray-400 cursor-not-allowed focus:ring-gray-400"
                                                : "bg-pink-600 hover:bg-pink-500 focus:ring-pink-600")
                                        }
                                        onClick={() => {
                                            setTipErrorMessage(null);
                                            setTipped(true);
                                            setVT(vt - 1);
                                            setTipAmount(tipAmount + 1);
                                            // Optimistically reflect the tap immediately in the
                                            // displayed total. The table-request unlock stays gated
                                            // on server confirmation (handled in tipSuccess).
                                            pendingOptimisticRef.current += 1;
                                            setTotalAmountTipped((prev) => prev + 1);
                                            showTipFloater();
                                            handleDebounceSearch();
                                        }}
                                    >
                                        TIP
                                        {tipped ? <CurrencyDollarIcon className="animate-ping h-7 w-7"
                                                                      aria-hidden="true"/> :
                                            <CurrencyDollarIcon className="h-7 w-7" aria-hidden="true"/>}
                                    </button>
                                </div>
                                <div className="mt-2">
                                    {tipErrorMessage && <LoginError errorMessage={tipErrorMessage}/>}
                                </div>
                            </div>
                            <div className="mx-auto mt-4 flex max-w-3xl flex-col items-center">
                                {vt != null && vt > 0 && <span
                                    className="inline-flex items-baseline gap-1.5 rounded-xl bg-pink-50 dark:bg-pink-950/40 px-4 py-2 ring-1 ring-inset ring-pink-200 dark:ring-pink-800">
                                    <span className="text-xl font-bold text-pink-700 dark:text-pink-300">{<NumericFormat value={vt} displayType={'text'}
                                                                    thousandSeparator={true}/>}</span>
                                    <span className="text-sm font-semibold text-gray-600 dark:text-pink-200">VirtualTipz remaining</span>
                                </span>}
                                {vt != null && vt <= 0 &&
                                    <button
                                        type="button"
                                        onClick={() => navigate('/user/buy')}
                                        className="inline-flex items-center justify-center rounded-xl bg-pink-600 px-5 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-pink-500 active:scale-95"
                                    >
                                        Out of VT — Buy More
                                    </button>
                                }
                            </div>
                            {/* Table request — matches the marketing page look & feel */}
                            {tableRequestFeatureFlag && <div className="mx-auto mt-6 w-full max-w-xs">
                                {hasRequestedTable ? (
                                    <div className="rounded-xl bg-green-50 px-4 py-3 ring-1 ring-green-200 text-center">
                                        <p className="text-sm font-semibold text-green-700">
                                            &#10003; Request sent to {dancer.name}
                                        </p>
                                        <p className="mt-0.5 text-xs text-green-600">
                                            She&apos;ll be told you&apos;re at table {tableId}
                                        </p>
                                        <p className="mt-1 text-xs text-green-600">
                                            (Table Requests Are Not Guaranteed)
                                        </p>
                                    </div>
                                ) : showTableForm ? (
                                    <div className="rounded-xl bg-white dark:bg-gray-800 px-4 py-4 ring-1 ring-gray-200 dark:ring-gray-700">
                                        <label className="block text-left text-xs font-semibold text-gray-700 dark:text-gray-200">
                                            Your table number
                                        </label>
                                        <input
                                            type="number"
                                            inputMode="numeric"
                                            name="tableId"
                                            value={tableId || ""}
                                            onChange={(event) => setTableId(event.target.value)}
                                            placeholder="e.g. 12"
                                            className="mt-1.5 block w-full rounded-lg border-0 py-2 text-center text-gray-900 dark:text-gray-100 dark:bg-gray-800 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (tableId) {
                                                    tableRequest(venueId, dancer.id, tableId, tableRequestSuccess, tableRequestError, getAccessToken);
                                                }
                                            }}
                                            disabled={!tableId || String(tableId).trim() === ""}
                                            className="mt-3 w-full rounded-lg bg-pink-600 py-2.5 text-sm font-semibold text-white transition hover:bg-pink-500 disabled:cursor-not-allowed disabled:opacity-40"
                                        >
                                            Submit request
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={() => setShowTableForm(true)}
                                        disabled={!hasTipped}
                                        className={
                                            "w-full rounded-xl py-3 text-sm font-semibold transition " +
                                            (hasTipped
                                                ? "bg-gray-900 text-white hover:bg-gray-800"
                                                : "cursor-not-allowed bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 ring-1 ring-gray-200 dark:ring-gray-700")
                                        }
                                    >
                                        {hasTipped
                                            ? "\uD83E\uDE91 Request to my table"
                                            : `Tip ${Math.max(minimumTableRequestTip - totalAmountTipped, 0)} more VT to unlock table request`}
                                    </button>
                                )}
                            </div>}
                        </blockquote>}
                        {!dancer && !isPageLoading && <blockquote className="mt-10">
                            <div className="mx-auto max-w-3xl text-center text-2xl font-medium leading-9 text-gray-900 dark:text-gray-100">
                                <p>
                                    No one is on Stage at this time.
                                </p>
                            </div>
                            <div
                                className="mx-auto mt-1 max-w-3xl text-center text-sm font-bold leading-9 text-gray-900 dark:text-gray-100">
                                {vt != null && <p>
                                    <span
                                        className="inline-flex items-center rounded-md bg-pink-50 dark:bg-pink-950/40 px-2 py-1 text-sm font-bold text-gray-900 dark:text-pink-200 ring-1 ring-inset ring-pink-700/10 dark:ring-pink-800">
                                        {<NumericFormat value={vt} displayType={'text'}
                                                                        thousandSeparator={true}/>} &nbsp; VirtualTipz remaining
                                    </span>
                                </p>}
                                {
                                    vt <= 0 && <p>Go BUY MORE VirtualTipz!</p>
                                }
                            </div>
                        </blockquote>}
                        {!dancer && isPageLoading && <blockquote className="mt-10">
                            <div className="mx-auto max-w-3xl text-center text-2xl font-medium leading-9 text-gray-900 dark:text-gray-100">
                                <p>
                                    <Skeleton variant="rounded"/>
                                </p>
                            </div>
                        </blockquote>}
                    </div>
                </div>
            </section>
            {venueId &&
                <SockJsClient url={baseUrl + '/ws'} topics={[vtDancerMessageURI + venueId]}
                              onMessage={onMessageReceive} ref={(client) => {
                    clientRef = client
                }}
                              onConnect={() => {
                                  //this.setState({clientConnected: true})
                              }}
                              onDisconnect={() => {
                                  // leaveGameSession();
                                  // if (onlineGameId && gamePendingStatus) {
                                  //     leaveGame(onlineGameId, () => {
                                  //     }, () => {
                                  //     });
                                  // }
                              }}
                              debug={false}/>
            }


        </>
    )
}
